import React from "react";
import Button from '@mui/material/Button';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useAddInsuranceHook from "./addInsuranceHook";


const initialState = {
    activeStatus: false,
    insuranceName: "",
    insuranceType: "",
    remarks: "",
    roomTypeID: "",
    bedStatus: "",
}
const AddInsurance = () => {
    const {
        insuranceState,
        handleInputChange,
        handleInsuranceSubmit,
        handleGoBack,
    } = useAddInsuranceHook(initialState);

    return (
        <>

            <form>
                <div className="basic-info" >
                    <div className="mt-2 ml-4">
                        <h4>Add Insurance</h4>
                        <div className="back-btn"
                            onClick={handleGoBack}
                        >
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Insurance Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountBalanceIcon /></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Insurance name" name="insuranceName"
                                        value={insuranceState?.insuranceName}
                                        onChange={handleInputChange} required
                                       
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Insurance Type*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Insurance Type" name="insuranceType"
                                        value={insuranceState?.insuranceType}
                                        onChange={handleInputChange} required
                                       
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Remarks</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Remarks" name="remarks"
                                        value={insuranceState?.remarks}
                                        onChange={handleInputChange} required
                                       
                                    />
                                </div>
                            </div>
                        </div>
                



                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2"
                        onClick={(event) => {
                            handleInsuranceSubmit(event)
                        }}
                    >Add Bed</Button>
                </div>
            </form>
        </>
    )
};

export default AddInsurance;